import { render, staticRenderFns } from "./SaveCache.vue?vue&type=template&id=07cc0710&scoped=true"
import script from "./SaveCache.vue?vue&type=script&lang=js"
export * from "./SaveCache.vue?vue&type=script&lang=js"
import style0 from "./SaveCache.vue?vue&type=style&index=0&id=07cc0710&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc0710",
  null
  
)

export default component.exports